/**
 *  AgileBPM 全局需要安装的组件
 * */
// 扩展的全局样式
import '@/components/ab-form/ab-iview.css'
import AbJwtSetting from '@/components/ab-base/ab-jwt-setting.js'
import AbHttpUtil from '@/components/ab-base/ab-http-util.js'
import AbTools from '@/components/ab-base/ab-tools.js'
import AbLoad from '@/components/ab-base/ab-load.js'
import abSave from '@/components/ab-base/ab-save.vue'
import abBtnRights from '@/components/ab-base/ab-btn-rights.js'
import abActionBtn from '@/components/ab-base/ab-action-btn.vue'
import AbBpmGridUtil from '@/components/ab-base/ab-bpm-grid-uitl.js'
import abGrid from '@/components/ab-grid/ab-grid.vue'
import abGridNoPage from '@/components/ab-grid/ab-gridNoPage.vue'
import abDateRange from '@/components/ab-grid/ab-date-range.vue'
import abCustDialog from '@/components/ab-cust-dialog/ab-cust-dialog.vue'
import abCustQuery from '@/components/ab-cust-dialog/ab-cust-query.js'
import abLoad from '@/components/ab-base/ab-load.vue'
import abImgPreviewer from '@/components/ab-form/custform-components/ab-img-previewer.vue'
import iPrint from '@/components/print/print.min';
import iRegion from '@/components/region/region.min';
import iIconSelect from '@/components/icon-select/icon-select.min';
import AbCheckboxGroup from '@/components/ab-form/custform-components/ab-checkbox-group.vue'

import Vue from 'vue';
 // 引入 AgileBPM相关的过滤器
import * as _filter from '@/components/ab-base/ab-filter.js'
Object.keys(_filter).forEach(item=>{
  Vue.filter(item,_filter[item])
})



export default {
    async install (Vue, options) {
		//jwt相关
       	Vue.use(AbJwtSetting)
   		 // http请求
       	Vue.use(AbHttpUtil)
       	// 工具类
		Vue.use(AbTools)
		// ab流程分页工具
		Vue.use(AbBpmGridUtil)
		// 自动加载数据指令
		Vue.directive('abLoad', AbLoad)
		Vue.component('abLoad', abLoad)
		//编辑页 通用保存按钮
		Vue.component('abSave', abSave)
		// 列表页简化开发
		Vue.component('abGrid', abGrid)
		Vue.component('abGridNoPage', abGridNoPage)
		// 动作按钮，触发一个后台请求
		Vue.component('abActionBtn', abActionBtn)
		// 自定义对话框
		Vue.component('abCustDialog', abCustDialog)
		// 自定义查询
		Vue.directive('abCustQuery', abCustQuery)
		// 权限指令，读取后端菜单按钮权限
		Vue.directive('abBtnRights', abBtnRights)
		//iview的日期范围的优化使用组件
		Vue.component('abDateRange', abDateRange)
		//ab的图片预览组件
		Vue.component('abImgPreviewer', abImgPreviewer)
		//ab checkbox优化组件
		Vue.component('AbCheckboxGroup', AbCheckboxGroup)
		
		// iview 打印组件
		Vue.use(iPrint)
		// 行政区域选择
		Vue.use(iRegion);
		// iview 图标选择
		Vue.use(iIconSelect);
    }
}
